// tipo de consulta para buscar o status da sincronização
export const SyncStatusTipo = {
    TODOS_COLABORADORES: 'todos-colaboradores',
    COLABORADOR: 'colaborador',
    FUNCOES: 'funcoes',
    DEPARTAMENTOS: 'departamentos',
    REGIMES: 'regimes',
};

export const SyncStatus = {
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED'
};

export const RelatoriosCreateStatus = {
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED',
    STOP: 'STOP',
    FAILED: 'FAILED'
};